import { Component } from '@angular/core';

@Component({
  selector: 'app-atualizar-consecana',
  templateUrl: './atualizar-consecana.component.html',
  styleUrl: './atualizar-consecana.component.css'
})
export class AtualizarConsecanaComponent {

}
